import { AnimatedContainer, AnimatedSection } from '@components/animated'
import { useTranslation } from 'react-i18next'
import { RentModel } from 'types/api'

import { Card } from '@/components/ui/card'

import AllRentsPaid from './AllRentsPaid'
import RentPayment from './RentPayment'
import { PaidRentWidget } from './RentWidget'

interface RentsProps {
  rents: RentModel[]
  paidRents: RentModel[]
}

const Rents = ({ rents, paidRents }: RentsProps) => {
  const { t } = useTranslation('contract')
  return (
    <AnimatedContainer staggerDelay={0.15}>
      <div className="space-y-8">
        <AnimatedSection>
          <div>
            <h2 className="mb-5 mt-0 font-display text-xl font-bold tracking-tight text-ink">
              {t('rent_table.rents.actual_payments')}
            </h2>
            {rents.length > 0 ? (
              <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                {rents.map((rent) => (
                  <RentPayment key={rent.id} rent={rent} />
                ))}
              </div>
            ) : (
              <AllRentsPaid />
            )}
          </div>
        </AnimatedSection>

        {paidRents.length > 0 && (
          <AnimatedSection>
            <div>
              <h2 className="mb-5 mt-0 font-display text-xl font-bold tracking-tight text-ink">
                {t('rent_table.rents.paid_payments')}
              </h2>
              <Card className="overflow-hidden rounded-2xl p-0">
                <PaidRentWidget paidRents={paidRents} />
              </Card>
            </div>
          </AnimatedSection>
        )}
      </div>
    </AnimatedContainer>
  )
}

export default Rents
